import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { SecurityService, WorkflowContextService } from 'src/app/services';
import { applicantHomeRoutesNames } from 'src/app/services/mock-data/applicant-home-constants/applicant-home-constants';
import { Images } from 'src/assets/export.assets';

@Component({
  selector: 'wm-edit-profile',
  standalone: false,
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class EditProfileComponent implements OnInit {
  geoPermitsLogo = Images.geoPermitsLogo
  dummyProfilePic = Images.dummyProfilePic
  headerLayout : 'staff' | 'applicant' | 'none' = 'none'
  constructor(
    private router: Router,
    public context : WorkflowContextService,
    private securitySvc : SecurityService,
    private dialog: MatDialog,
    private route : ActivatedRoute
  ) { }
  profileImageClass!: string;

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const from = params.get('from');
      if (from === 'staff' || from === 'applicant') {
        this.headerLayout = from;
      } else {
        this.headerLayout = 'none';
      }
    })
//added by priya 29-01-2026
    const hasProfileImage = !!this.context.user?.userProfileImageURL

    // this.profileImageSrc = hasProfileImage
    //   ? this.context.user.userProfileImageURL
    //   : Images.dummyProfilePic

    this.profileImageClass = hasProfileImage
      ? 'profile-image'
      : 'applicant-profile-pic'
  
//end by priya 29-01-2026

  }
  title = 'Profile Works';
  onBack() {
    this.router.navigate([
      applicantHomeRoutesNames.root,
      applicantHomeRoutesNames.applyForPermit.route,
      'building'
    ]);
  }
  onGeoPermitLogoClick = ()=>{
  this.router.navigate(['/']);
}
getAdminButtonData = ()=>{
    return {
      text : 'Admin',
      onClick :()=>{
        this.router.navigate(['/admin']);
      }
    }
  }
  
  signOutModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Confirm Sign Out',
    modalSubDescp: 'This will end your session, are you sure you\nwant to sign out?',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };
  getSignOutButtonData = () => {
    return {
      text: 'Sign Out',
      onClick: () => {
        this.signOutModalData = {
          ...this.signOutModalData,
          open: true
        }

      }
    }
  }
  handleSignOutModalAccepted() {
    this.securitySvc.logout().subscribe(() => {
      this.router.navigate(['/']);
    });
  }

  onSignOutClick = () => {
    this.signOutModalData = {
      ...this.signOutModalData,
      open: true
    };
  };

  handleSignOutModalModalRejected() {
    this.signOutModalData = {
      ...this.signOutModalData,
      open: false
    };
  }
 
   //added by priya 29-01-2026

  logoSrc = Images.geoPermitsLogo;
  // added by priya 10-02-2026
  get profileImageSrc(): string {
    const path = this.context.user?.userProfileImageURL;
    if (!path) {
      return Images.dummyProfilePic;
    }
  
    return path.startsWith('http')
      ? path
      : `${window.location.origin}${path}`;
  }
    // end by priya 10-02-2026

    showProfileMenu = true;
  menuButtons = [
    {
      text: 'Admin',
      onClick: () => {
        this.router.navigate(['/admin']);
      }
    },
    {
      text: 'Sign Out',
      onClick: () => {
        this.signOutModalData = {
          ...this.signOutModalData,
          open: true
        }
      }
    }
  ];
  
  logoApplicantSrc=Images.geoPermitsLogoWhiteBg //code added by Sanchit on 03/18/2026
  // logoApplicantSrc='favicon.ico'
  userNameData = {
    text: this.context.user?.name 
  };
  showProfileMenuOfApplication = true;


  //end by priya 29-01-2026

  //added by omkar on 18/03/2026
    goToEditProfile = () => {
    this.router.navigate(['/auth', 'edit-profile'], {
      queryParams: { from: 'applicant' }
    });
  };

  goToChangePassword = () => {
    this.router.navigate(['/auth', 'change-password'], {
      queryParams: { from: 'applicant' }
    });
  };
  // end by omkar on 18/03/2026

}
